import validate from 'lib/utils/validationRules';

export default function serializeParams(params, prefix) {
  const result = [];
  Object.keys(params).forEach(key => {
    const arg = prefix
      ? prefix + '[' + key + ']'
      : key;

    const v = params[key];
    const isObject = v !== null && typeof v === 'object';
    result.push(isObject ? serializeParams(v, arg) : encodeURIComponent(arg) + '=' + encodeURIComponent(v));
  });
  return result.join('&');
}

export function getQueryParamsAsObject(searchString) {
  return searchString
    .split('&')
    .reduce((acc, curr) => {
      const p = curr.split('=');
      acc[decodeURIComponent(p[0])] = decodeURIComponent(encodeURIComponent(p[1]));

      return acc;
    }, {});
}

export function replaceURL(parameters) {
  if (validate.isEmptyObject(parameters)) {
    return;
  }

  try {
    window.history.replaceState({}, '', `${window.location.origin}${window.location.pathname}?${serializeParams(parameters)}`);
  } catch (error) {
    console.log(error);
  }
}
